import * as React from "react";

import { nullElement } from "../../TypingUtils";

import { Root } from "./Header.styles";

interface HeaderProps {
    children?: JSX.Element;
}

export function Header(props: HeaderProps): JSX.Element | null {
    if (props.children) {
        return <Root data-tid={"Header"}>{props.children}</Root>;
    }
    return nullElement;
}
